import React from 'react';
import { createRoot } from 'react-dom/client';
import SchulzugMap from '../../../js/map/index';
window.addEventListener('trafimage-map-loaded', () => {
    const container = document.getElementById('plf-trafimage-id-1');
    if (!container) {
        console.error('Trafimage container not found');
        return;
    }
    const root = createRoot(container);
    // @ts-ignore
    root.render(React.createElement(SchulzugMap, null));
});
